import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const seen = (data) =>
  axios({
    method: 'post',
    url: config.endpoints.mnemonics.seen,
    headers: getHeaders(true),
    data
  })

const get = () => 
  axios({
    method: 'get',
    url: config.endpoints.mnemonics.get,
    headers: getHeaders(true)
  })

export default {
  seen,
  get
}